export class InfoPrograma {
  programaId?: number;
  objetivoGeneral?: string;
  objetivoEspecifico?: string;
  perfilEgresado?: string;
  campoLaboral?: string;
  tipoAccion?: number;
  nombre?: string;
}
